import { z } from "zod";

export const Event = z.object({
    id: z.number(),
    host: z.string().nullable(),
    title: z.string(),
    type: z.enum(["COMPASS", "EXTERNAL", "HOLIDAY", "OTHER"]),
    url: z.string().nullable(),
    description: z.string().nullable(),
    start: z.date(),
    end: z.date().nullable(),
    category: z.string().nullable(),
    priceRange: z.string().nullable(),
    location: z.string().nullable(),
    latitude: z.number().nullable(),
    longitude: z.number().nullable(),
    imageUrl: z.string().nullable(),
    thumbnailUrl: z.string().nullable(),
});
